// @flow

/**
 * The character # is reserved in URLs as the start of a fragment identifier.
 * You must encode this as %23 for the (background-image) URL to be valid (and to work in Firefox).
 * @param svg
 * @return {string}
 */
export default (svg: string) => svg.replace(/#/g, '%23');
